<template lang="html">
  <svg
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 0 33.977 30"
  ><defs></defs><g transform="translate(0 0)"><g transform="translate(-3.023 -5)"><path d="M37,8a3,3,0,0,0-3-3H6a3,3,0,0,0-1,5.82V26a5,5,0,0,0,5,5h9v2H14a1,1,0,0,0,0,2H26a1,1,0,0,0,0-2H21V31h9a5,5,0,0,0,5-5,1,1,0,1,0-2,0,3,3,0,0,1-3,3H10a3,3,0,0,1-3-3V11H8A1,1,0,0,0,8,9H6A1,1,0,0,1,6,7H34a1,1,0,0,1,0,2H12a1,1,0,0,0,0,2H33v9a1,1,0,0,0,2,0V10.82A3,3,0,0,0,37,8Z"/><path d="M20.22,19.13l-2,2.49a9,9,0,0,1-7,3.38,1,1,0,0,0,0,2,10.93,10.93,0,0,0,8.59-4.13l2-2.49a9,9,0,0,1,7-3.38,1,1,0,1,0,0-2,10.93,10.93,0,0,0-8.59,4.13Z"/></g></g></svg>
</template>

<script>
  import mixinIcons from '../mixins/mixin-icons.js'

  export default {
    mixins: [
      mixinIcons
    ]
  };
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/icons/StudydashIcon.vue